export function setToken(token) {
  return window.localStorage.setItem("token", token)
}

export function getToken() {
  if (typeof window !== "undefined") {
    return window.localStorage.getItem("token")
  }
}

export function deleteToken() {
  return window.localStorage.removeItem("token")
}
